import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { belongsTo } from '@apexdesigner/schema-tools';

export const personalInformation = z
  .object({
    id: z.number().hidden().describe('Unique identifier'),

    lastName: z
      .string()
      .nullable()
      .optional()
      .describe('Last name as in passport.'),

    firstName: z
      .string()
      .nullable()
      .optional()
      .describe('First name as in passport.'),

    patronymic: z
      .string()
      .nullable()
      .optional()
      .describe('Patronymic as in passport.'),

    dateOfBirth: z
      .string()
      .nullable()
      .optional()
      .presentAs('date')
      .describe('Date of birth.'),

    gender: z
      .enum(['Male', 'Female'])
      .nullable()
      .optional()
      .describe('Gender.'),

    countryOfBirth: z
      .string()
      .nullable()
      .optional()
      .describe('Country of birth as in passport.'),

    cityOfBirth: z
      .string()
      .nullable()
      .optional()
      .describe('City of birth as in passport.'),

    countryOfResidence: z
      .string()
      .nullable()
      .optional()
      .describe('Country of residence.'),

    citizenship: z.string().nullable().optional().describe('Citizenship.'),

    candidateId: z.number().hidden().describe('Foreign key to Candidate'),

    candidate: belongsTo('Candidate'),
  })
  .describe('Passport-based identity details for a candidate.')
  .as('PersonalInformation');

export { personalInformation as personalInformationSchema };
